module.exports = __webpack_public_path__ + "static/media/0_2018_12_31.df9885db.jpg";